import axios from "axios";

import { authHeader } from "src/api/authHeader";
import { ENTITY_ANALYTICS_PATH } from "src/api/middlewares/utils";
import { Environment } from "src/hooks/useEnvironment";

export type EntityAnalyticsEvent =
  | "entity_related_case_detail_opened"
  | "entity_related_case_opened"
  | "entity_case_created";

export const trackEntityAnalyticsEvent = (
  baseUrl: string | undefined,
  event: EntityAnalyticsEvent,
  env: Environment,
): void => {
  if (!baseUrl) {
    return;
  }

  // Shared axios instance: 401 retry still runs. Fire-and-forget middleware
  // skips the 403 toast; the catch keeps a metrics failure off the error page.
  void axios
    .post(
      `https://${baseUrl}${ENTITY_ANALYTICS_PATH}`,
      { event, env },
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeader(false),
        },
      },
    )
    .catch(() => undefined);
};
